// extracted by mini-css-extract-plugin
export default {"root":"Versions_root__5K8QE","main":"Versions_main__WsM4T","block":"Versions_block__Y-mWD","centered":"Versions_centered__XLh-v","errorMessage":"Versions_errorMessage__JVczd"};